import React, { Component, PropTypes } from 'react';
import './styles/PaginationButton.scss';
import classNames from 'classnames';

const PaginationButton = (props) => {
    const buttonClasses = classNames({
        [props.type] : true,
        'paginationButton': true,
        'disabled': props.disabled
    });

    const handleClick = () => {
        if(!props.disabled) {

            if(props.type === 'next') {
                const nextPage = props.activePage + 1;
                if(nextPage <= props.pages) {
                    return props.onClick(nextPage);
                }
            }

            if(props.type === 'prev') {
                const prevPage = props.activePage - 1;
                if(prevPage >= 1) {
                    return props.onClick(prevPage);
                }
            }
        }
    };

    return (
        <div className={buttonClasses} onClick={handleClick}>
            {props.children}
        </div>
    )
};

PaginationButton.propTypes = {
    type: PropTypes.oneOf(['next', 'prev']),
    disabled: PropTypes.bool.isRequired,
    activePage: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired
};

PaginationButton.defaultProps = {
    type: 'next',
    disabled: false,
};

export default PaginationButton;



// WEBPACK FOOTER //
// ./src/_app/estimations/modals/components/Pagination/PaginationButton.js